import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { MwFormDataService } from '../@services/form-data.service';
import { MwFormBaseSectionComponent } from './../section-base.component';

export const MwFormSectionComponentSelector = 'mw-form-section';

@Component({
  selector: MwFormSectionComponentSelector,
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MwFormSectionComponent
  implements AfterViewInit, OnDestroy, MwFormBaseSectionComponent
{
  static id = 1;
  @ViewChild('content') templateRef: TemplateRef<any>;

  @HostBinding(`class.${MwFormSectionComponentSelector}`)
  hasHostClass = true;

  @Input() hasToggle = false;
  @Input() isToggleDisabled = false;
  @Input() foldable = false;
  @Input() isHideContent = false;

  @HostBinding(`attr.id`)
  idAttr = `mw-from-section-${MwFormSectionComponent.id++}`;

  @Input() title: string;
  @Input() icon: string;
  @Input() subTitle: string;
  @Input() defaultSubTitle: string;
  @Input() isOutlineIcon: boolean;
  @Input() subTitleIndicators: string;
  @Input() orderIndex = MwFormSectionComponent.id;
  @HostBinding(`style.--mw-form-section-divider-width`)
  @Input()
  sectionDividerWidth: number = null;

  readonly isFormTitle = false;

  @Output() hideChange = new EventEmitter<boolean>();

  constructor(
    private readonly dataService: MwFormDataService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.dataService.addSection(this);
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.dataService.removeSection(this);
  }

  hideContent(hide: boolean): void {
    this.isHideContent = hide;
    this.hideChange.emit(hide);
  }
}
